import { observable, action, runInAction, computed } from 'mobx';
import service from '@service/index';
import fetchUrl from '@service/fetchUrl';

class ItemStore {
  constructor() {

  }

  init () {

  }

  /**
   * 控制 modal 是否显示
   */
  @observable
  is_modal_show = false;

  /**
   * 账户信息
   * @type {null}
   */
  @observable
  record = {};

  /**
   * 打开 modal 显示
   */
  @action
  openModal(record) {
    if( record == undefined) {
      console.error(`record is ${record}`);
      return;
    }
    this.record = record;
    this.record.tempRadio = record.radio * 100;
    this.is_modal_show = true;
  }

  /**
   * 关闭 modal 显示
   */
  @action
  closeModal() {
    this.record = {};
    this.is_modal_show = false;
  }

  /**
   * 转移指定会员
   * @param {*} params
   */
  async moveProxyRelation( params ) {
    let url = fetchUrl.agent.moveProxyRelation;
    let result = await service.fetchData({
      path: url,
      params: {
        muid: this.record.id,
        ...params
      }
    });
    // console.log(result)
    return result;
  }
}

let item_store = new ItemStore();
export default item_store;



// WEBPACK FOOTER //
// ./src/Store/Agent/ChangeAgentStore.js